import { CSSObject } from '@chakra-ui/react';
import { CustomButtonProps } from '@/components/Button/Button';
import { ContainerForms } from '../../styles/account.styles.puntgenie';

export const buttonTakeBreakProps: CustomButtonProps = {
  variant: 'solid',
  lineHeight: 'normal',
  h: '38px',
};

export const ListItemExclusionItem: CSSObject = {
  fontSize: 'xs',
};

export const HeadingInformation: CSSObject = {
  color: 'gamma.600',
  fontWeight: 'medium',
  mb: '0',
  fontSize: 'sm',
};

export const TextInformation: CSSObject = {
  fontSize: 'xs',
  mb: '3',
  color: 'gamma.600',
  '&:first-of-type': {
    fontWeight: 'medium',
  },
};

export const BoxStyledLink: CSSObject = {
  color: 'gamma.600',
  textDecoration: 'underline',
};

export const TextM: CSSObject = {
  fontSize: 'sm',
  color: 'gamma.600',
  fontWeight: 'medium',
  mb: '1',
};

export const TextS: CSSObject = {
  fontWeight: 'medium',
  color: 'gamma.600',
  fontSize: 'xs',
  '&:first-of-type': {
    mb: '2',
  },
};

export const BoxTakeABreak: CSSObject = {
  pb: '0',
  border: 'none',
};

export const TextDate: CSSObject = {
  fontSize: 'md',
  color: 'gamma.600',
};

export const TextDateLabel: CSSObject = {
  color: 'gamma.600',
  fontSize: 'sm',
  fontWeight: 'medium',
};

export const TextConfirmBreak: CSSObject = {
  fontSize: 'xs',
  fontWeight: 'medium',
};

export const BoxTakeABreakWrapper: CSSObject = {
  borderBottom: 'none',
  pb: '0',
};

export const InputContainer: CSSObject = {
  ...ContainerForms,

  '.chakra-form__label': {
    ...TextDateLabel,
  },
};

export const buttonConfirmBreakProps: CustomButtonProps = {
  height: '38px',
  variant: 'secondary',
};
